import { render, staticRenderFns } from "./RepeatServiceListV2.vue?vue&type=template&id=76add31c&scoped=true&"
import script from "./RepeatServiceListV2.vue?vue&type=script&lang=js&"
export * from "./RepeatServiceListV2.vue?vue&type=script&lang=js&"
import style0 from "./RepeatServiceListV2.vue?vue&type=style&index=0&id=76add31c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76add31c",
  null
  
)

export default component.exports